import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

// Sales order lines a production order line can be pegged to (the make-to-order link).
// Scoped to the order's customer - a customer's open lines is a short list, so this is a
// dropdown rather than the XL search modal.
@Injectable({
  providedIn: 'root',
})
export class SalesOrderLineReferenceService extends BaseReferenceService {
  constructor() {
    super('SalesOrderLineReference');
  }

  // Scoped by production order, not customer - the line modal knows its header, and the
  // API resolves the customer from it. Empty for a make-to-stock order.
  getForProductionOrder(productionOrderHeaderId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductionOrder/${productionOrderHeaderId}`);
  }
}
